import React from "react";
import { useLiburTahunan } from "./useLiburTahunan";
import "./LiburTahunan.css";

const byBagian = (a, b) => {
  if (a.bagian < b.bagian) return -1;
  if (a.bagian > b.bagian) return 1;
  return 0;
};

const byDate = (a, b) => new Date(a.date) - new Date(b.date);

// Tabel karyawan dipakai dua kali (di bawah setahun & setahun)
const PeopleTable = ({ title, rows }) => (
  <section className="libur-panel">
    <div className="libur-heading">
      <h3>{title}</h3>
      <span>{rows ? rows.length : 0} orang</span>
    </div>
    <div className="libur-table-scroll">
      <table className="libur-table">
        <thead>
          <tr>
            <th className="col-no">No.</th>
            <th>Nama</th>
            <th>Bagian</th>
            <th>Kontrak Awal</th>
          </tr>
        </thead>
        <tbody>
          {rows &&
            rows.map((ele, index) => (
              <tr key={`${ele.name}-${index}`}>
                <td className="col-no">{index + 1}.</td>
                <td>{ele.name.split(" ").slice(0, 3).join(" ")}</td>
                <td>{ele.bagian}</td>
                <td className="col-date">{ele.kontrakAwal}</td>
              </tr>
            ))}
        </tbody>
      </table>
      {(!rows || rows.length === 0) && (
        <div className="libur-empty">Belum ada data.</div>
      )}
    </div>
  </section>
);

const LiburTahunan = () => {
  const {
    tanggal,
    setTanggal,
    handleAddTanggalWhitelist,
    listTanggal,
    pickTanggal,
    setPickTanggal,
    listOrang,
    handleExportExcel,
    handleDeleteTanggal,
  } = useLiburTahunan();

  // salin dulu sebelum sort supaya state dari hook tidak ikut berubah
  const sortSetahun = listOrang && [...listOrang.setahun].sort(byBagian);
  const sortBelumSetahun = listOrang && [...listOrang.dibawah].sort(byBagian);
  const sortTanggal = listTanggal && [...listTanggal].sort(byDate);

  return (
    <div className="container-liburtahunan">
      <div className="wrapper-card-liburtahunan">
        <div className="warning-liburtahunan" role="note">
          <span className="warning-icon" aria-hidden="true">
            &#9888;
          </span>
          <div className="warning-text">
            <p>
              Karyawan yang <b>di bawah</b> 1 tahun saat libur tahun baru dan
              Idul Fitri, hari kerjanya tidak +1
            </p>
            <p>
              Karyawan yang <b>1 tahun atau lebih</b> saat libur tahun baru dan
              Idul Fitri hari kerja +1, dan jika masuk kerja dihitung lembur
              dengan catatan nama karyawan tersebut ada dalam daftar lembur yang
              dibuat oleh Ka. Shift / Ka.Bag
            </p>
          </div>
        </div>

        <div className="libur-actions">
          <div className="libur-card">
            <h3>Tambah tanggal libur</h3>
            <div className="libur-row">
              <input
                className="libur-input"
                type="date"
                aria-label="Pilih tanggal"
                value={tanggal}
                onChange={(e) => setTanggal(e.target.value)}
              />
              <button
                className="libur-btn libur-btn-primary"
                onClick={() => handleAddTanggalWhitelist()}
              >
                Add
              </button>
            </div>
          </div>

          <div className="libur-card">
            <h3>Pilih tanggal</h3>
            <div className="libur-row">
              <select
                className="libur-select"
                aria-label="Pilih tanggal libur"
                value={pickTanggal}
                onChange={(e) => setPickTanggal(e.target.value)}
              >
                <option disabled value="Pilih Tanggal">
                  Pilih Tanggal
                </option>
                {sortTanggal &&
                  sortTanggal.map((ele) => (
                    <option key={ele.date} value={ele.date}>
                      {ele.date}
                    </option>
                  ))}
              </select>
              <button
                className="libur-btn libur-btn-success"
                onClick={() => handleExportExcel()}
              >
                Export
              </button>
              <button
                className="libur-btn libur-btn-danger"
                onClick={() => handleDeleteTanggal()}
              >
                Delete Tanggal
              </button>
            </div>
          </div>
        </div>

        <div className="display-flex-mobile-liburtahunan">
          <PeopleTable title="Dibawah Setahun" rows={sortBelumSetahun} />
          <PeopleTable title="Setahun" rows={sortSetahun} />
        </div>
      </div>
    </div>
  );
};

export default LiburTahunan;
